import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-03/lesson-09/task-03";

const task: Slide = {
  titleHtml: "What follows from the property that ray tracing is stochastic?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
